export const SET_COLORS = "setColors";
export const UPDATE_COLOR = "updateColor";
